var languageFile = require("../../../../public/languages/Translation");
module.exports = {
    landingpageTabs: [{ label: 'Dashboard', value: 'DASHBOARD' },
    { label: 'Insights', value: 'INSIGHTS' },
    // { label: 'Local Performance', value: 'LPO' },
    { label: languageFile[localStorage.getItem('language')]["25691"], value: 'REVIEWS' },
    { label: 'Manage Locations', value: 'MANAGE_LOCATIONS' },
    { label: 'Competitors', value: 'COMPETITORS' },
    { label: languageFile[localStorage.getItem('language')]["25701"], value: 'MANAGE_LOCATIONS_BULK' },
    { label: languageFile[localStorage.getItem('language')]["25711"], value: 'POST_SCHEDULE' },
    { label: languageFile[localStorage.getItem('language')]["27771"], value: 'POST_INSIGHTS' },
    {label: languageFile[localStorage.getItem('language')]["27731"], value: 'QA'},
    {label: languageFile[localStorage.getItem('language')]['29051'], value: 'REVIEW_SHOWCASE'},
    {label: languageFile[localStorage.getItem('language')]['20761'], value: 'AUTO_RESPONSE'},
    {label: 'Image Management', value: 'IMAGE_MANAGEMENT'}

    ],
    mappingTabName: {
        'DASHBOARD': 'Dashboard',
        'INSIGHTS': 'Insights',
        // 'PERFORMANCE':'Performance',
        // 'LPO': 'Local Performance',
        'REVIEWS': languageFile[localStorage.getItem('language')]["25691"],
        'MANAGE_LOCATIONS': 'Manage Locations',
        'COMPETITORS': 'Competitors',
        'MANAGE_LOCATIONS_BULK': languageFile[localStorage.getItem('language')]["25701"],
        'POST_SCHEDULE': languageFile[localStorage.getItem('language')]["25711"],
        'POST_INSIGHTS': languageFile[localStorage.getItem('language')]["27771"],
        'QA': languageFile[localStorage.getItem('language')]["27731"],
        'REVIEW_SHOWCASE': languageFile[localStorage.getItem('language')]['29051'],
        'AUTO_RESPONSE': languageFile[localStorage.getItem('language')]['20761'],
        'IMAGE_MANAGEMENT': 'Image Management'
    },
    tabRedirectionMapping: {
        'DASHBOARD': '/dashboard',
        'INSIGHTS': '/insights',
        // 'PERFORMANCE':'/performance',
        // 'LPO': '/localperformance',
        'REVIEWS': '/reviews',
        'MANAGE_LOCATIONS': '/managelocations',
        'COMPETITORS': '/competitor?view=reporting',
        'MANAGE_LOCATIONS_BULK': '/locationbulkupdate',
        'POST_SCHEDULE': '/posts/createpost',
        'POST_INSIGHTS': '/localpostinsights',
        // 'SETTINGS': '/settings/addAccount',
        'QA':'/qareviews',
        'REVIEW_SHOWCASE': '/widgetshowcase',
        'AUTO_RESPONSE': '/autoresponse',
        'IMAGE_MANAGEMENT': '/imagemanagement',
    },
    tabMapping: {
        '/dashboard': 'DASHBOARD',
        // '/performance' : 'PERFORMANCE',
        '/insights' : 'INSIGHTS',
        '/localperformance' : 'LPO',
        '/reviews' : 'REVIEWS' ,
        '/managelocations' :  'MANAGE_LOCATIONS',
        '/competitor?view=reporting' : 'COMPETITORS',
        '/locationbulkupdate' : 'MANAGE_LOCATIONS_BULK',
        '/posts/createpost' : 'POST_SCHEDULE' ,
        '/posts' : 'POST_SCHEDULE' ,
        '/localpostinsights' : 'POST_INSIGHTS',
        // '/settings/addAccount' : 'SETTINGS',
        '/qareviews' : 'QA',
        '/widgetshowcase' : 'REVIEW_SHOWCASE',
        '/autoresponse' : 'AUTO_RESPONSE', 
        '/imagemanagement': 'IMAGE_MANAGEMENT',
        '/realitycheck': 'REALITY_CHECK'
    },
    settingLabelMap: {
        AUTHORIZE_ACCOUNT: "Authorize Account",
        GOOGLE_AUDIT: "Google Audit",
        INTEGRATIONS: "Integrations",
        MANAGE_ROLES: "Manage Roles",
        REVIEW_SETTINGS: "Review Settings",
        //CAMPAIGN_BUILDER: 'Review Auto Response',
        REPORT_MANAGEMENT: "Report Management",
        DATA_DOWNLOADS: "Data Downloads",
        PROFILE_DETAILS: "Profile Details",
        CUSTOME_SIDEBAR: "Custom Navigation",
        CLAIM_LOCATION: "Claim Location",
        REVIEW_CLARITY: "Review Clarity",
        MANAGE_FILTERS: "Manage Filters",
        MANAGE_TEAMS: "Manage Teams",
        MANAGE_AI_TONE: "Manage AI Agents"
    }

}
